
import React, { Component } from 'react';
import {
    message,
    Table,
    Select,
    Drawer,
    Switch,
    Row,
    Button,
    Input,
    Form,
    Modal,
    Popconfirm,
    Tooltip,
    notification,
    Radio,
    Col,
    Divider,
    Card,
    Upload,
    Avatar,
    Typography,
    Tag,
    Slider,
    InputNumber,
    Badge,
    Skeleton

} from 'antd';

import { Link } from 'react-router-dom';

import {
    PlusOutlined,
    DeleteOutlined,
    ReloadOutlined,
    InfoOutlined,
    CheckOutlined,
    CloseOutlined,
    EyeOutlined,
    EyeInvisibleOutlined
} from '@ant-design/icons';


import { inject, observer } from 'mobx-react';

import moment from 'moment'

import axios from "axios"

import _ from "lodash"

import { withTranslation } from 'react-i18next';

import NavbarPanel from '../components/NavbarPanel';
import { LoadingGlobal } from '../components/LoadingGlobal';
import { toJS } from 'mobx';
import { formatMyMoney } from '../helper';


const queryString = require('query-string');

const { Search, TextArea } = Input;

const { Option } = Select;
const { Text } = Typography;



@inject('UserStore')
@observer
export default class User extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            data: [],
            userTypes: [
                { title: "Web Kullanıcı", value: 4 },
                { title: "Bayi", value: 3 },
                { title: "Admin", value: 2 },
                { title: "Süper Admin", value: 1 },
                { title: "Joker", value: 0 },
            ],
            workTypes: [
                { title: "Girişten", value: 0 },
                { title: "Kasadan", value: 1 },
            ],
            modalOpenCreate: false,
            credit: 0,
            percent: 0,
            workType: 1,
            page: 'list',
            userType: _.get(this.props.UserStore, "user.userType", 4) + 1
        }
    }

    componentDidUpdate = () => {
        //   console.log("componentDidUpdate")
    }

    componentDidMount = async () => {

        const parsedHash = queryString.parse(location.search);
        const userId = _.get(parsedHash, "who")
        console.log("-------------------------------", { userId })

        let data = _.get(this.props.UserStore, "users", [])
        if (data.length == 0) {
            this.getItems()
        }

    }

    //#liste
    getItems = async () => {
        this.props.UserStore.getUsers();
    }

    resetState() {
        this.setState({
            _id: '',
            name: '',
            password: '',
            username: '',
            page: 'list',
            modalOpenCreate: false,
        })
    }

    reload = () => {
        this.getItems()
        this.resetState()
    }
    //#ekle
    handleCreate = async (action) => {
        if (action == "reset-password") {
            console.log("yeni şifre set et")
            const { password, _id } = this.state
            if (password) {
                const toData = {
                    password,
                    type: 'by-parent',
                    _id
                }
                try {
                    const sData = await this.props.UserStore.resetPassword(toData)
                    console.log({ sData })
                    message.success()
                    this.resetState()
                } catch (error) {
                    console.log({ error })
                    message.error(_.get(error, "response.data.message", ""))
                }
            }


        }
        else if ("create-user") {
            try {
                const sData = await this.props.UserStore.register(this.state)
                message.success()
                this.resetState()
                this.getItems()
            } catch (error) {
                console.log({ error })
                message.error(_.get(error, "response.data.error", ""))
            }
        }
    }

    //#sil
    confirmDelete = async (item) => {
        console.log(item)
        try {
            const serverData = await this.props.ProductStore.deleteCategory(item._id)
            console.log(serverData)
            this.state.data = _.remove(this.state.data, (o) => {
                return o._id != item._id
            })
            //  console.log({items})
            //  const dd =[]
            //  dd.splice(1)
            this.setState({ data: this.state.data })

        } catch (error) {
            console.log(error)
        }

    }
    // confirmGetOut Sistemden Atmak

    confirmGetOut = async (item) => {
        try {
            const serverData = await this.props.UserStore.getOut(item._id)
            this.getItems()
            message.success()

        } catch (error) {
            console.log(error)
        }
    }

    //düzenle click
    clickEdit = (item) => {
        this.setState({
            ...item,
            //   page: 'edit'
        }, () => {
            this.setState({ modalOpenCreate: true })
        })
    }





    handleCancel() {
        // this.resetState()
        /*
        this.setState({
          modalOpenCreate: false,
        })
      */
        this.setState({
            modalOpenCreate: false,
        })
    }




    onChange(e) {
        this.setState({ [e.target.name]: e.target.value })
    }
    onChangeCredit = (e) => {
        this.setState({ credit: e })
    }

    onChangeSwitchList = async (checked, item) => {
        console.log(checked);
        console.log({ item: toJS(item) });
        message.destroy()
        try {
            const serverData = await this.props.UserStore.setActive(item._id, checked)
            // checked ? message.success() : message.error()
            console.log(serverData)

        } catch (error) {
            console.log(error)
            message.warn()
        }
    }

    onClickNetwork = (item) => {

        this.props.UserStore.getUsers(item._id).then(res => {
            console.log("onClickNetwork", { res })
            this.setState({ ...item, page: 'network' })
        });
        //  this.forceUpdate()


        /*
          const users = _.get(item, "users", [])
          if (users.length > 0) {
              this.setState({ page: 'network' })
              console.log("onClickNetwork", toJS(item))
          }
          */

    }

    onBlurPercent = (percent) => {
        if (percent > 100) {
            this.setState({
                percent: 100
            })
        }
        if (percent < 0) {
            this.setState({
                percent: 0
            })
        }

    }

    render() {
        const { user } = this.props.UserStore

        const { workTypes, page } = this.state
        const { loading } = this.props.UserStore


        const data = this.props.UserStore.users
        //   const data = this.props.UserStore.getUserss


        const { credit } = this.state;

        let userTypes = this.state.userTypes

        userTypes = _.filter(userTypes, (o) => {
            return o.value == _.get(user, "userType", 4) + 1
        })

        // kredi (online kullanıcı)
        let userCredit = _.get(user, "credit", 0)

        const activeUserType = _.get(user, "userType", 4)





        const handleFocus = (event) => event.target.select();

        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16, offset: 0 },
            },
        };


        const columns = [
            {
                title: 'Kullanıcı Adı',
                key: 'userType',
                render: (text, record) => <span>
                    <Badge status={record.online ? "success" : undefined}>
                        {record.username}
                        {` `}  <Text type="secondary" >{record.name ? " (" : ""}
                            {record.name}
                            {record.name ? ")" : ""}
                        </Text>
                    </Badge>

                </span>
            },
            {
                title: 'Son Görülme',
                key: 'lasOnline',
                render: (text, record) => <span>
                    <Tooltip title={new Date(record.lasOnline).toLocaleString()}>
                        {
                            record.lasOnline
                                ?
                                moment(record.lasOnline).fromNow()
                                :
                                <div />
                        }
                    </Tooltip>

                </span>
            },
            {
                title: 'Kullanıcı Tipi',
                key: 'userType',
                render: (text, record) => <span>
                    {_.get(_.find(this.state.userTypes, { value: record.userType }), "title", "")}
                </span>
            },
            {
                title: 'Kredi',
                dataIndex: 'credit',
                key: 'credit',
            },
            {
                title: 'Bakiye (₺)',
                key: 'balance',
                render: (text, record) => <span>
                    {formatMyMoney(record.balance)}
                </span>
            },
            {
                title: 'Ağı',
                key: 'users',
                render: (text, record) =>
                    <span>
                        {
                            _.get(record, "users", []).length
                                > 0
                                ?
                                <Badge
                                    //status={true}
                                    count={_.get(record, "users", []).length}
                                >
                                    {
                                        //   <Link to={`/panel/user?who=${record._id}`}>
                                        //   </Link>
                                    }
                                    <Button
                                        onClick={() => this.onClickNetwork(record)}
                                        size="small"
                                    >Ağ</Button>
                                </Badge>
                                :
                                "Bulunamadı"
                        }

                    </span>
            },
            {
                title: 'Oluşturma',
                key: 'created',
                render: (text, record) => <Tooltip title={moment(record.created).fromNow()}>
                    {new Date(record.created).toLocaleDateString()}
                </Tooltip>
            },
            {
                title: 'Durum',
                key: 'active',
                render: (text, record) => <span>
                    <Switch
                        title="Durum"
                        // size={'small'}
                        onChange={(e) => this.onChangeSwitchList(e, record)}
                        //  checked={record.active}
                        defaultChecked={_.get(record, "active", false)}
                        checkedChildren={<CheckOutlined />}
                        unCheckedChildren={<CloseOutlined />}
                    />
                </span>
            },
            {
                title: 'İşlem', key: 'action', render: (record) => {
                    return (
                        <span>
                            <Button icon={<InfoOutlined />} onClick={() => this.clickEdit(record)}
                                size="small">
                                Detay
                            </Button>
                            <Divider type="vertical" />

                            {
                                /**

                         <Button onClick={() => this.clickEdit(record)} size="small">
                                Detay
                            </Button>
                            <Divider type="vertical" />
                            
                            
                            
                            
                            
                            <Button size="small" type="primary" icon={<InfoOutlined/>}/>
                                                  <Divider type="vertical"/>

                                                    <Popconfirm okText="Evet" cancelText="Hayır" title={`Emin misiniz? ${_.get(record, "products", []).length > 0 ? `Kategoriye ait ${_.get(record, "products", []).length} adet ürün de silinecektir!!` : ""}`}
                                onConfirm={() => { this.confirmDelete(record) }}>
                                <Button type="danger" size="small">
                                    Sil
                            </Button>
                            </Popconfirm>
                            <Divider type="vertical" />
                                 */
                            }

                            <Popconfirm okText="Evet" cancelText="Hayır" title={`Sistemden Kullanıcıyı Atmak Üzeresiniz, İşleme devam etmek ister misin?  ${_.get(record, "products", []).length > 0 ? `Kategoriye ait ${_.get(record, "products", []).length} adet ürün de silinecektir!!` : ""}`}
                                onConfirm={() => { this.confirmGetOut(record) }}>
                                <Button type="danger" size="small">
                                    Sistemden At
                            </Button>
                            </Popconfirm>
                        </span>
                    )
                }
            },
        ];



        if (activeUserType == 3) {
            columns.splice(2, 1);
        }





        return (
            <div>
                <NavbarPanel page="user" />
                {
                    //  <LoadingGlobal loading={!user || loading} />
                }
                <Card
                    loading={loading}
                    title={
                        <span>
                            {
                                page == "list"
                                &&
                                <span>
                                    Kullanıcılarım <Text type="secondary">({data.length})</Text>
                                </span>
                            }
                            {
                                page == "network"
                                &&
                                <span>
                                    {_.get(this.state, "username")}
                                    /
                                    {_.get(this.state, "name")}
                                    kişisinin kullanıcıları
                                    {` `}
                                    <Text type="secondary">({data.length})</Text>
                                    {` `}
                                    <Button
                                        onClick={() => {
                                            this.props.UserStore.getUsers()
                                            this.resetState()
                                        }
                                        }
                                        type="primary"
                                        size="small"
                                        shape="circle-outline"
                                        title="Geri" icon={<CloseOutlined />} />

                                </span>
                            }
                        </span>




                    }
                    extra={<span>

                        {
                            /*
                                                    <Button
                                                    icon={<PlusOutlined />}
                                                    style={{ marginLeft: '8px' }}
                                                    onClick={() => this.setState({ modalOpenCreate: true, modalTitle: "Yeni" })} />
                            */
                        }
                        <Button type="primary"
                            shape="circle"
                            icon={<ReloadOutlined />}
                            style={{ marginLeft: '8px' }}
                            onClick={() => this.reload()} />
                    </span>}
                >


                    <div>
                        <Skeleton loading={loading}>
                            <Table
                                bordered={true}
                                rowKey={'_id'}
                                columns={columns}
                                pagination={false}
                                size="small"
                                dataSource={data}
                                loading={loading}
                            />
                        </Skeleton>

                    </div>

                </Card>


                <Modal
                    title={this.state._id ? "Düzenle" : "Yeni"}
                    placement="left"
                    width={720}
                    visible={this.state.modalOpenCreate}
                    onCancel={(e) => this.handleCancel(e)}
                    onOk={(e) => this.handleCancel(e)}
                    bodyStyle={{ paddingBottom: 80 }}
                >

                    <Form {...formItemLayout}>
                        <Form.Item
                            label="Kullanıcı adı"
                            required
                        >
                            <Input
                                readOnly={true}
                                value={this.state.username}
                                onChange={(e) => this.onChange(e)}
                                name="username"
                            />
                        </Form.Item>

                        <Form.Item
                            label="Şifre"
                            required
                        >
                            <Input
                                value={this.state.password}
                                onChange={(e) => this.onChange(e)}
                                type={this.state.passwordVisible ? "text" : "password"}
                                name="password"
                                suffix={<span>
                                    <Button size="small" shape="circle-outline"
                                        icon={this.state.passwordVisible ? < EyeOutlined /> : <EyeInvisibleOutlined />}
                                        onClick={() => this.setState({ passwordVisible: !this.state.passwordVisible })}
                                    />
                                </span>}
                            />

                            <Button style={{ marginTop: 20 }} block onClick={() => this.handleCreate('reset-password')} type="primary">
                                Şifreyi Sıfırla
                </Button>
                        </Form.Item>
                    </Form>
                </Modal>

            </div >
        )
    }
}
